import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetOtherBranchCustomerCountResponse {
    total_order_count: number;
    total_order_amount: number;
    payment_complete_count: number;
    pending_count: number;
}

export const useGetOtherBranchCustomerCount = (
    customerIdx: number,
    startDate?: Date,
    endDate?: Date,
): UseQueryResult<GetOtherBranchCustomerCountResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetOtherBranchCustomerCountResponse, Error>({
        queryKey: ["getOtherBranchCustomerCount", customerIdx, startDate, endDate],
        queryFn: async () => {
            const response = await axios.get(
                `${enum_api_uri.get_settlements_customer_count.replace(":customer_idx", customerIdx.toString())}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    params: {
                        start_date: startDate ? startDate.toISOString().split("T")[0] : undefined,
                        end_date: endDate ? endDate.toISOString().split("T")[0] : undefined,
                    },
                },
            );
            return response.data.data;
        },
        placeholderData: prevData => prevData,
    });
};
